<template>
  <div v-loading="loading">
    <div class="table-header mt-4">
      <div class="flex items-center">
        <!-- <div class="mr-2 filter">
          <img src="@/assets/images/icons/filter.svg" alt="filter icon" />
        </div> -->
        <div class="table__search-input-wrapper">
          <span class="pr-2 opacity-50"><search-icon /> </span>

          <input
            type="text"
            class="table__search-input"
            placeholder="Search..."
            v-model="query"
          />
          <img src="@/assets/images/icons/search.svg" alt="search icon" />
        </div>
      </div>

      <div class="date-picker flex items-center justify-center">
        <p class="text-xs">Date Filter:</p>
        <el-date-picker
          v-model="filter.startDate"
          type="date"
          placeholder="Pick start date"
          class="mx-1"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
        <el-date-picker
          v-model="filter.endDate"
          type="date"
          placeholder="Pick end date"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </div>
      <!-- <base-button text="Filter" /> -->
    </div>
    <!-- <div class="flex justify-end" @click="resetFilter">
      <base-button text="Reset" p="px-6 py-1" />
    </div> -->
    <div class="flex justify-end my-4">
      <bulk-action class="mr-8" :display="isBulkAction">
        <p class="pb-2" @click="deleteSelected">Delete Selected</p>
        <p class="pb-2" @click="shareSelected">Share Selected</p>
      </bulk-action>
      <router-link :to="{ name: 'PromotionForm' }">
        <primary-button buttonText="New Promotion" />
      </router-link>
    </div>

    <div class="responsive-table" id="table-wrapper">
      <table class="custom-table responsive-table">
        <thead>
          <tr>
            <th>
              <base-checkbox v-model="selectAllPromotions" />
            </th>
            <th>PROMO NAME</th>
            <th>PROMO CODE</th>
            <th>LOYALTY CATEGORY</th>
            <th>START DATE</th>
            <th>END DATE</th>
            <th>BOQ</th>
            <th>STATUS</th>
            <th>
              ACTION
            </th>
          </tr>
        </thead>
        <!-- {{
          selectedLeads
        }} -->
        <tbody>
          <tr
            v-for="promotion in filteredPromotions"
            :key="promotion.id"
            class="cursor-pointer"
          >
            <td>
              <base-checkbox
                :value="promotion.id"
                v-model="selectedPromotionIds"
              />
            </td>
            <td>{{ promotion.name }}</td>
            <td>{{ promotion.promoCode }}</td>
            <td>
              {{ promotion.loyaltyCategory }}
            </td>
            <td>
              {{ promotion.startDate | formatDate }}
            </td>
            <td>{{ promotion.endDate | formatDate }}</td>
            <td>View</td>
            <td>{{ promotion.promoStatus }}</td>

            <td class="relative" tabindex="-1" @blur="selectedRowId = null">
              <span
                @click="
                  selectedRowId
                    ? (selectedRowId = null)
                    : (selectedRowId = promotion.id)
                "
                ><vertical-ellipsis
              /></span>
              <action-popup width="w-48" v-if="selectedRowId == promotion.id">
                <div class="cursor-pointer">
                  <p class="py-1" @click="editPromo(promotion.id)">
                    View & Edit Promo
                  </p>
                  <p class="py-1" @click="shareSelected">
                    Share Promo
                  </p>
                  <p class="py-1" @click="deletePromo(promotion.id)">
                    Delete Promo
                  </p>
                </div>
              </action-popup>
            </td>
          </tr>
        </tbody>
      </table>

      <div v-if="!filteredPromotions.length">
        <empty-table-icon />
        <p class="text-center text-sm">No promotions found!</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      filter: {
        startDate: null,
        endDate: null,
      },
      promotions: [],
      selectAllPromotions: false,
      selectedRowId: "",
      selectedPromotionIds: [],
      loading: false,
      query: "",
    };
  },
  computed: {
    isBulkAction() {
      return this.selectedPromotionIds.length ? true : false;
    },
    filteredPromotions() {
      return this.filterArray(this.promotions, this.query);
    },
  },
  watch: {
    selectAllPromotions(val) {
      if (val) {
        this.promotions.forEach((promotion) => {
          this.selectedPromotionIds.push(promotion.id);
        });
      } else {
        this.selectedPromotionIds = [];
      }
    },
    "filter.endDate"() {
      if (this.filter.startDate && this.filter.endDate) {
        this.getDateFilteredPromotions();
      }
    },
  },
  mounted() {
    this.getAllPromotions();
  },
  methods: {
    async getAllPromotions() {
      this.loading = true;
      try {
        const response = await this.$_getAllPromotions();
        this.logResponse(response);
        this.promotions = response.data.promotions;
      } catch (error) {
        this.handleError(error);
      }
      this.loading = false;
    },
    async getDateFilteredPromotions() {
      this.loading = true;
      try {
        const response = await this.$_filterPromotionsByDate(this.filter);
        this.logResponse(response);
        this.promotions = response.data.promotions;
      } catch (error) {
        this.handleError(error);
      }
      this.loading = false;
    },
    selectPromotion(id) {
      this.selectedPromotionIds.push(id);
    },
    unselectPromotion(id) {
      let indexOfId = this.selectedPromotionIds.indexOf(id);
      this.selectedPromotionIds.splice(indexOfId, 1);
    },
    async deletePromo(promoId) {
      this.generateToast("Deleting promo!", "success");
      try {
        const response = await this.$_deletePromotion(promoId);
        this.logResponse(response);
        this.generateToast("Promo Deleted!", "success");
        this.getAllPromotions();
      } catch (error) {
        this.handleError(error);
      }
    },
    deleteSelected() {
      this.generateToast("Deleting selected!", "success");
      this.selectedPromotionIds.forEach((id) => {
        this.deletePromo(id);
      });
    },
    shareSelected() {
      this.generateToast("Sharing Selected!", "success");
      setTimeout(() => {
        this.generateToast("Promo shared!", "success");
      }, 6000);
    },
    editPromo(promotionId) {
      this.$router.push(`/crm/promotions/new?id=${promotionId}`);
    },
    resetFilter() {
      this.filter = {
        startDate: null,
        endDate: null,
      };
      this.getAllPromotions();
    },
  },
};
</script>

<style scoped>
.table__search-input-wrapper {
  background: #ffffff;
  width: 20vw;
}
th,
td {
  padding: 0.75rem;
}
td {
  background: #ffffff;
  color: var(--primaryblue);
  font-weight: 500;
}
th {
  font-size: 0.9rem;
  font-weight: 600;
}
table {
  border-collapse: separate;
  border-spacing: 0 0.5rem;
}
</style>
